export enum ApplicantTrackerResources {
    PrevAndNextApplicant = '/v2/applicantTracker/applicants/:id',
    Kanban = '/v2/applicantTracker/jobPostings/:jobPostingId/kanbans',
    Duplicate = '/v2/applicantTracker/funnelTemplates/:funnelTemplate/duplicate',
    BulkApplicantMessage = '/v2/applicantTracker/sendBulkApplicantIndividualMessage',
    ApplicantIndividualTestMessage = '/v2/applicantTracker/sendApplicantIndividualTestMessage',
    AssignInterviews = '/v2/applicantTracker/interviews/:interview/assign',
    AssignHiringTeam = '/v2/applicantTracker/jobPostings/:jobPosting/assign',
    SubscribeToTopic = '/v2/applicantTracker/subscriptions/subscribe/:topic',
    UnsubscribeFromTopic = '/v2/applicantTracker/subscriptions/unsubscribe/:topic',
    SubscriptionStatusForTopic = '/v2/applicantTracker/subscriptions/status/:topic',
}
